import Radio from 'backbone.radio';
import Api from '@/lib/api/api';
import session from '@/models/v5/session';
import ls from '@/collections/v5/logstream';

    var globalCh = Radio.channel('global');
    var routerCh = Radio.channel('router');
    var apiCh = Radio.channel('api');
    export default function logout() {
        session.reset();

        // Disconnect logstream
        ls.disconnect();
        // Stop listening to 401's and showing the invalid session dialog
        apiCh.off('401');
        apiCh.off('invalidSession');
        Api.stop_expiry_timer();
        // Close the WebSocket and load the login page
        var ws = globalCh.request('websocket');
        if (ws) { ws.close(); }
        
        routerCh.request('set_location', 'login');
        globalCh.request('login');
    }

